export * from "./api/get-mailbox-params.schema";
export * from "./api/get-mailboxes-query.schema";
export * from "./mailbox.schema";
